import ReactMarkdown from "react-markdown";

const styles = {
  wrapper: {
    display: "grid",
    padding: "10px 20px",
    marginBottom: "10px",
    borderRadius: "10px",
    color: "white",
    width: "fit-content",
    maxWidth: "90%",
    lineHeight: "1.6",
  },
};

export default function Message({ source, content }) {
  const wrapperStyle = {
    ...styles.wrapper,
    backgroundColor: source === "user" ? "#1b1b1d" : "#007bff",
    marginLeft: source === "user" ? "0px" : "auto",
    marginRight: source === "user" ? "auto" : "0px",
  };
  return (
    <div style={wrapperStyle}>
      <div>
        {source === "user" ? content : <ReactMarkdown children={content} />}
      </div>
    </div>
  );
}
